import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Subscription } from 'rxjs';
import { SessionStorageService } from '../services/session-storage.service';
import { PageDetailHeroComponent } from '../shared/page-layout/page-detail-hero.component';
import { PageShellComponent } from '../shared/page-layout/page-shell.component';
import { Company } from './company.model';
import { CompanyGroupAccessComponent } from './company-group-access/company-group-access.component';
import { TenantScopeService } from './tenant-scope.service';

@Component({
    selector: 'app-company-groups-page',
    standalone: true,
    imports: [
        CommonModule,
        RouterLink,
        ButtonModule,
        TagModule,
        PageShellComponent,
        PageDetailHeroComponent,
        CompanyGroupAccessComponent
    ],
    template: `
        <app-page-shell>
            <app-page-detail-hero
                eyebrow="Organization"
                title="Company Groups"
                [subtitle]="currentCompany?.name || 'Manage group membership, group users, and child-company access.'"
                icon="pi pi-sitemap">
                <div tags>
                    <p-tag *ngIf="currentCompany?.id" [value]="'Company ' + (currentCompany?.id || '')" severity="info"></p-tag>
                    <p-tag *ngIf="currentCompany?.name" [value]="currentCompany?.name || ''" severity="success"></p-tag>
                </div>
                <div actions>
                    <a pButton routerLink="/company" icon="pi pi-building" label="Open Company Settings" severity="secondary" [outlined]="true"></a>
                </div>
            </app-page-detail-hero>

            <app-company-group-access [company]="currentCompany"></app-company-group-access>
        </app-page-shell>
    `
})
export class CompanyGroupsPageComponent implements OnInit, OnDestroy {
    currentCompany?: Company;
    private readonly subscriptions = new Subscription();

    constructor(
        private readonly sessionStorageService: SessionStorageService,
        private readonly tenantScopeService: TenantScopeService
    ) {}

    ngOnInit(): void {
        this.refreshCurrentCompany();
        this.subscriptions.add(this.tenantScopeService.activeScope$.subscribe(() => this.refreshCurrentCompany()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private refreshCurrentCompany(): void {
        this.currentCompany = this.sessionStorageService.getCompany() ?? undefined;
    }
}
